import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface ExperienceReviewStats {
  experienceId: string;
  avgScore: number;
  count: number;
}

async function fetchReviewStats(): Promise<Record<string, ExperienceReviewStats>> {
  const { data: rawData, error } = await supabase
    .from("v_public_reviews" as any)
    .select("experience_id, nps_score")
    .not("nps_score", "is", null);

  if (error || !rawData) return {};

  const data = rawData as unknown as { experience_id: string; nps_score: number }[];

  const map: Record<string, { total: number; count: number }> = {};
  for (const r of data) {
    if (!map[r.experience_id]) {
      map[r.experience_id] = { total: 0, count: 0 };
    }
    map[r.experience_id].total += r.nps_score!;
    map[r.experience_id].count += 1;
  }

  const result: Record<string, ExperienceReviewStats> = {};
  for (const [id, stats] of Object.entries(map)) {
    result[id] = {
      experienceId: id,
      avgScore: Math.round(((stats.total / stats.count) / 2) * 10) / 10,
      count: stats.count,
    };
  }
  return result;
}

export function useExperienceReviews() {
  return useQuery({
    queryKey: ["experience-review-stats"],
    queryFn: fetchReviewStats,
    staleTime: 5 * 60 * 1000,
  });
}
